import classes from "./AdTab.module.scss";
import { AdTabProps } from "./config/tab";
import { memo, PropsWithChildren, useCallback } from "react";
import { useExperiments } from "hooks/useExperiments";

const AdTab = ({ link, children }: AdTabProps & PropsWithChildren) => {
  const { noAds = false } = useExperiments();

  const handleClick = useCallback(() => {
    window.location.href = link;
  }, [link]);

  if (noAds) {
    return null;
  }

  return (
    <span className={classes.advertTab} onClick={handleClick}>{children}</span>
  );
};

const adTabMemo = memo(AdTab);

export default adTabMemo;
